import MappingBase from './mappingBase.js';
import category_mapping from './categoryMappings.json';

class ServiceCategory extends MappingBase {
  constructor({
    id = null,
    name = null,
    description = null,
    sortOrder = 0,
    isActive = true,
    icon = null,
    color = null,
    level = null,
    parentCode = null,
    canonicalName = null,
    translations = null,
    vitrina_category_description = '',
    hide_category_name_on_home = false,
    hide_category_services = false,
    block_category_booking = false
  } = {}) {
    super();
    this.id = id;
    this.name = name;
    this.description = description;
    this.sortOrder = sortOrder;
    this.isActive = isActive;
    this.icon = icon;
    this.color = color;
    this.level = level;
    this.parentCode = parentCode;
    this.canonicalName = canonicalName;
    this.translations = translations;
    this.vitrina_category_description = vitrina_category_description;
    this.hide_category_name_on_home = hide_category_name_on_home;
    this.hide_category_services = hide_category_services;
    this.block_category_booking = block_category_booking;
  }

  static _aliasMapping = {
    ...category_mapping,
    id: "id",
    nm: "name",
    desc: "description",
    so: "sortOrder",
    ia: "isActive",
    cl: "color",
    ic: "icon",
    uhc: "id",
    cn: "canonicalName",
    uhlv: "level",
    uhpc: "parentCode",
    utr: "translations"
  };
}

export default ServiceCategory;
